import React from 'react'
import { IonPopover, IonContent } from '@ionic/react'
import { IEdisuPopoverProps } from './edisu-popover-props.interface'

const EdisuPopover: React.FC<IEdisuPopoverProps> = ({ triggerId, submitted, children, extraClassName = '' }) => {
  return (
    <IonPopover
      className={'search-form-popover ' + extraClassName}
      showBackdrop={false}
      arrow={false}
      trigger={submitted ? undefined : triggerId + '-trigger'}
      triggerAction="click"
    >
      <IonContent className="ion-padding">{children}</IonContent>
    </IonPopover>
  )
}

export default EdisuPopover
